








































import BehaviorConfig from '@/models/app-config/behavior/behavior'
import _ from 'lodash'

import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import PaymentService from '@/services/api/payment'
import HostFreeAreaService from '@/services/free-area/host-free-area'
import InquiryFreeAreaService from '@/services/free-area/inquiry/inquiry-free-area'
import {
  createInquiryKindRepository
} from '@spa/components/organisms/inquiry/model/inquiry-kinds/inquiry-kinds-repository'
import { log } from '@spa/log'
import LoadingMixin from '@spa/mixins/loading'
import FormValidationMixin from '@spa/mixins/validation/VeeValidateForm'
import MailService from '@spa/services/api/mail'
import { CookieService } from '@spa/services/cookie'
import { User } from '@spa/store/modules/user/types'

import {
  InquiryForm,
  InquiryKind,
  InquirySection,
} from '../../organisms/inquiry/model/InquiryKind'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { ApiContent } from '@/models/api/content'
import { ApiPaymentSettingList } from '@/models/api/payment/setting'
import { InstanceResolver } from '@/util/instanceResolver'
import InquiryComplete from '../../templates/InquiryComplete.vue'
import InquiryConfirm from '../../templates/InquiryConfirm.vue'
import InquiryTop from '../../templates/InquiryTop.vue'

@Component({
  components: {
    'spa-inquiry-top': InquiryTop,
    'spa-inquiry-confirm': InquiryConfirm,
    'spa-inquiry-complete': InquiryComplete,
    SpaErrorDialog,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class Inquiry extends Mixins<FormValidationMixin>(FormValidationMixin) {
  status: InquiryStatus = InquiryStatus.Pending

  freeAreas: ApiContent[] = []
  showModal: boolean = false
  modalMessage: string | null = null

  readonly paymentService: PaymentService = new PaymentService()
  paymentSettings: ApiPaymentSettingList = ApiPaymentSettingList.empty()

  readonly behavior: BehaviorConfig = BehaviorConfig.createFromBrand(null) // ホスト単位固定

  form: InquiryForm = {
    kind: null,
    detail: null,
    brand: null,
    lastName: null,
    firstName: null,
    lastKana: null,
    firstKana: null,
    tel1: null,
    tel2: null,
    tel3: null,
    email1: null,
    email2: null,
    order: null,
    content: null,
    images: [],
  }

  kindLabels: InquiryKind[] = []

  sections: Map<string, any> | null = null

  get freeAreaService(): HostFreeAreaService {
    return HostFreeAreaService.createForHost(
      InquiryFreeAreaService
    )
  }

  async created() {
    this.paymentSettings = await this.fetchPaymentSettings()

    this.kindLabels = await createInquiryKindRepository(this.behavior)
      .listForHost({ paymentSettings: this.paymentSettings })

    if (CookieService.isLogined()) {
      this.form = await this.setDefaultFormValues()
    } else {
      // お問い合わせ種類・詳細だけは未ログインでも子コンポーネントに渡す
      this.form.kind = this.initialKind
      this.form.detail = this.initialDetail
    }
    // お問い合わせ種類・詳細を選択できる場合、初期値を渡す
    let defaultContent: string | undefined
    if (this.canModifyKind) {
      this.form.kind = this.kindLabels[0].value
      this.form.detail = this.kindLabels[0].details[0].value
      defaultContent = this.kindLabels[0].details[0].defaultContent
    } else {
      const selectedKind = this.kindLabels.find((k) => {
        return k.value === this.form.kind
      })
      if (selectedKind) {
        const selectedDetail = selectedKind.details.find((d) => {
          return d.value === this.form.detail
        })
        if (selectedDetail) {
          defaultContent = selectedDetail.defaultContent
        }
      }
    }
    // デフォルト文が設定された場合、その内容を設定
    if (defaultContent) {
      this.form.content = defaultContent
    }

    this.freeAreas = await this.freeAreaService.fetch()
  }

  get initialKind(): string | null {
    return typeof this.$route.query.kind === 'string' ? this.$route.query.kind : null
  }

  get initialDetail(): string | null {
    return typeof this.$route.query.detail === 'string' ? this.$route.query.detail : null
  }

  get canModifyKind(): boolean {
    // 種類・詳細の初期値によって変更可能かどうか決める
    return this.initialKind === null && this.initialDetail === null ||
           this.initialKind === 'free' && this.initialDetail === 'free'
  }

  get user(): User {
    return this.$store.state.user.user
  }

  get isOrderRequired(): boolean {
    // query stringによって注文番号が必須かどうか判断する
    // TODO query stringが'afterOrder'の場合、
    // 最近の注文履歴によって注文番号が必須かどうか判断する
    return this.$route.query.isOrderRequired === 'true'
  }

  get inputHandler(): (value: string|number, field: string) => void {
    // 子コンポーネントからのイベントハンドラ
    return (value, field) => {
      // フォーム内容を更新
      this.form[field] = value

      switch (field) {
        case 'kind':
          let selectedKind = this.kindLabels.find((k) => {
            return k.value === this.form.kind
          })
          if (selectedKind) {
            // お問い合わせ種類が変更された場合、詳細を初期化
            this.form.detail = selectedKind.details[0].value
            // デフォルト文が設定された場合、その内容を設定
            if (selectedKind.details[0].defaultContent) {
              this.form.content = selectedKind.details[0].defaultContent
            } else {
              this.form.content = ''
            }
          }
          break
        case 'detail':
          selectedKind = this.kindLabels.find((k) => {
            return k.value === this.form.kind
          })
          if (selectedKind) {
            // お問い合わせ種類が変更された場合、詳細を初期化
            const selectedDetail = selectedKind.details.find((d) => {
              return d.value === this.form.detail
            })
            if (selectedDetail) {
              if (selectedDetail.defaultContent) {
                this.form.content = selectedDetail.defaultContent
              } else {
                this.form.content = ''
              }
            }
          }
          break
      }
    }
  }

  get uploadImageHandler(): (file: File|null, index: number) => void {
    return (file, index) => {
      if (file === null) {
        this.setModal('アップロードできる写真は8MB未満です。')

        return
      }

      this.$set(this.form.images, index, file)
    }
  }

  get deleteImageHandler(): (index: number) => void {
    return (index) => {
      this.$delete(this.form.images, index)
    }
  }

  async submit() {
    if (this.status === InquiryStatus.Pending) {
      const validated = await this.validateForm()
      if (!validated) {
        return
      }
      this.sections = this.makeSections(this.form)
      this.status = InquiryStatus.Confirmed
    } else if (this.status === InquiryStatus.Confirmed) {
      try {
        this.status = InquiryStatus.Loading
        const sections = this.sections! // 入力→確認画面の段階でmakeSectionsを使って作成済みのはず

        const form = Array.from(sections).reduce(
          (prev: object, [key, value]) => ({
            ...prev,
            [key]: value.content,
          }),
          {}
        )

        await MailService.sendInquiryForm(form, this.form.images)
        // TODO: 失敗した場合、何を表示するべきか
        this.status = InquiryStatus.Completed
      } catch (err) {
        log.error(err)

        // TODO: Alert some reason
        this.setModal('お問い合わせの送信に失敗しました。時間をおいて再度お試しください。')

        this.status = InquiryStatus.Confirmed

        return
      }
    }
    window.scrollTo(0, 0)
  }

  setModal(message: string) {
    this.showModal = true
    this.modalMessage = message
  }

  clearModal() {
    this.showModal = false
    this.modalMessage = null
  }

  back() {
    if (this.status === InquiryStatus.Confirmed) {
      this.status = InquiryStatus.Pending
      window.scrollTo(0, 0)
    }
  }

  private async validateForm(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  get kindString(): string {
    const kind = this.kindLabels.find(k => k.value === this.form.kind)

    if (!kind) {
      return '無し'
    }
    if (this.form.detail) {
      const detail = kind.details.find(d => d.value === this.form.detail)
      if (detail) {
        return [kind.text, detail.text].join('--')
      }
    }

    return kind.text
  }

  private makeSections(form: InquiryForm): Map<string, InquirySection> {
    // TODO: use object literal insted of map
    const sections: Map<string, InquirySection> = new Map()

    if (InstanceResolver.isMulti()) {
      sections.set('brand', {
        index: 2,
        title: '対象ブランド',
        content: form.brand!,
        // FIXME データ構造の管理方法から考えたほうが良いかも. 一旦突貫.
        // 他にも色々、このタイミングで要求が出てきているので、一度ちゃんと整理したほうが良い
        ...(form.brand === 'MyColor' ? { label: 'その他' } : {}),
      })
    }

    sections.set('kind', {
      index: 1,
      title: 'お問い合わせ種類',
      content: this.kindString,
    })
    sections.set('name', {
      index: 3,
      title: 'お名前',
      content: `${form.lastName}　${form.firstName}`,
    })
    sections.set('kana', {
      index: 4,
      title: 'フリガナ',
      content: `${form.lastKana}　${form.firstKana}`,
    })
    const tel1 = form.tel1 || ''
    sections.set('tel', {
      index: 5,
      title: '電話番号',
      content: tel1 + form.tel2 + form.tel3,
    })
    sections.set('email', {
      index: 6,
      title: 'メールアドレス',
      content: form.email1!,
    })
    sections.set('order', {
      index: 7,
      title: '注文番号',
      content: form.order || '無し',
    })
    sections.set('content', {
      index: 8,
      title: 'お問い合わせ内容',
      content: form.content!,
    })

    return sections
  }

  get isLoading(): boolean {
    return this.status === InquiryStatus.Loading
  }

  get isPending(): boolean {
    return this.status === InquiryStatus.Pending
  }

  get isConfirmed(): boolean {
    return this.status === InquiryStatus.Confirmed
  }

  get isCompleted(): boolean {
    return this.status === InquiryStatus.Completed
  }

  private async setDefaultFormValues(): Promise<InquiryForm> {
    await this.$store.dispatch('user/get')

    return {
      kind: this.initialKind || null,
      detail: this.initialDetail || null,
      brand: null,
      lastName: this.user.last_name || null,
      firstName: this.user.first_name || null,
      lastKana: this.user.phonetic_last_name || null,
      firstKana: this.user.phonetic_first_name || null,
      // tslint:disable-next-line:no-magic-numbers
      tel1: this.user.tel ? this.user.tel.substr(0, 3) : null, // TODO telを一つにまとめる。子コンポーネントで3つに分ける。
      // tslint:disable-next-line:no-magic-numbers
      tel2: this.user.tel ? this.user.tel.substr(3, 4) : null,
      // tslint:disable-next-line:no-magic-numbers
      tel3: this.user.tel ? this.user.tel.substr(7) : null,
      email1: this.user.email || null,
      email2: this.user.email || null,
      order: null,
      content: null,
      images: [],
    }
  }

  private async fetchPaymentSettings(): Promise<ApiPaymentSettingList> {
    const result = await this.paymentService.setting()

    if (result.isLeft()) {
      log.error('Load error payment/setting')

      return ApiPaymentSettingList.empty()
    }

    return ApiPaymentSettingList.valueOf(result.value)
  }
}

enum InquiryStatus {
  Pending,
  Loading,
  Failed,
  Confirmed,
  Completed,
}
